import { render, staticRenderFns } from "./PlannedTasksFullCalendar.vue?vue&type=template&id=45395b41&scoped=true"
import script from "./PlannedTasksFullCalendar.vue?vue&type=script&lang=js"
export * from "./PlannedTasksFullCalendar.vue?vue&type=script&lang=js"
import style0 from "./PlannedTasksFullCalendar.vue?vue&type=style&index=0&id=45395b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45395b41",
  null
  
)

export default component.exports